import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function BasicColumnChart({
  title,
  series,
  labels,
  showYAxis = true,
  exportCSVHeading = "Date,",
  yaxisTitle = "",
  tooltip = "",
  dataLabelsShow = false,
}) {
  const chartRef = useRef(null);

  async function downloadPNG() {
    const chartInstance = chartRef.current;
    console.log("chartInstance ", chartInstance);
    const base64 = await chartInstance.chart.dataURI();
    console.log("base 64", base64.imgURI);
    const downloadLink = document.createElement("a");
    downloadLink.href = base64.imgURI;
    downloadLink.download = "image.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function exportCSV() {
    let csvContent =
      exportCSVHeading + series.map((s) => s.name).join(",") + "\n";

    labels.forEach((category, index) => {
      let row = [category];
      series.forEach((series) => {
        row.push(series.data[index]);
      });
      csvContent += row.join(",") + "\n";
    });
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function downloadChart() {
    const chartInstance = chartRef.current;
    if (chartInstance) {
      downloadPNG(chartInstance);
    } else {
      console.error(`Chart not found.`);
    }
  }

  const chartOption = {
    series: series || [],
    options: {
      chart: {
        type: "bar",
        height: 380,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: dataLabelsShow,
      },
      stroke: {
        width: 0,
        curve: "smooth",
      },
      markers: {
        size: [4, 7],
      },
      legend: {
        show: true,
        position: "bottom",
        showForSingleSeries: true,
        offsetY: 5,
        markers: {
          width: 10,
          height: 10,
          radius: 50,
          shape: "circle",
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      xaxis: {
        categories: labels || [],
        tickAmount: 6,
        labels: {
          show: true,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          formatter: function (value) {
            if (!value || !value.length) return value;
            return value?.replace(/([0-9]+)\s(\w+)/, (match, day, month) => {
              return `${day} ${month?.charAt(0)?.toUpperCase()}${month?.slice(
                1
              )}`;
            });
          },
        },
      },
      yaxis: {
        title: {
          text: yaxisTitle,
          style: {
            fontSize: "10px",
          },
          offsetX: 5,
        },
        labels: {
          show: showYAxis,
          formatter: function (value) {
            return value;
          },
        },
      },
    },
  };

  return (
    <Card className="flex-grow-1 d-flex flex-column">
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={true}
        needImageDownload={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
        downloadImage={downloadChart}
      />
      <Card.Body className="flex-grow-1">
        <div id="chart-basic-column-bar">
          <Chart
            ref={chartRef}
            options={chartOption.options}
            series={chartOption.series}
            type="bar"
            height={300}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default BasicColumnChart;
